import type { AuthProps } from "features/auth";
import type { Artist } from "features/reviewable";

/**
 * User has access to this artist profile
 */
const canEditProfile = ({
  user,
  roles,
  artist,
}: {
  user?: AuthProps["user"];
  roles: AuthProps["roles"];
  artist?: Artist;
}) =>
  roles?.showAdminFeatures ||
  (!!user && !!artist?.adminUsers?.includes(user.id));

export { canEditProfile };
